
<div :class="{ 'pointer-none': !enableMention }">
  <div id="editor"></div>
</div>
